/** 图文消息 */
<template lang="pug">
.arrControl
  Modal(v-model='value',width='860',:closable='false',:transfer='false',:footer-hide='true',:mask-closable='false')
    .Multiple
      .doPICTURETEXT
        .title  案例背景
        .stem  呈现案例政策背景和与之相关的焦点事件。除文字说明以外，也会通过视频和图片的形式帮助您更加详细的了解政策缘起的相关资料。
        img(src="../../assets/Noviceguide/xw.jpg").xw
        button.start(@click="start") 确定
      div(style="position:absolute;right: 15%;cursor: pointer;bottom: 10px;",@click="start")
          img(src="../../assets/Noviceguide/小手.png", alt="提示").finger
          p.text-Explain(style="top: 126%;")  了解完毕，点击确定
</template>
<script>
export default {
  data() {
    return {
      value: true
    };
  },
  methods: {
    start() {
      this.$emit("start");
    }
  }
};
</script>
<style lang="stylus" scoped>
.arrControl
  width 860px
  background rgba(255, 255, 255, 1)
  position fixed
  // top 100px
  // bottom 75px
  left 0
  right 0
  margin auto
  z-index 100
  text-align left
  margin-bottom 80px

  >>>.ivu-modal-body
    background #dddddd
  .com
    margin-bottom 20px
  .Multiple
    padding 36px 32px
.xw
    width: 50%;
    text-align: center;
    position: relative;
    left: 0;
    transform: translateX(50%);
    margin-top: 18px;
.doPICTURETEXT
  width 100%
  overflow auto
  position: relative;
  padding-bottom 30px
  .title
    font-size 20px
    font-family MicrosoftYaHeiUI-Bold
    font-weight bold
    color rgba(42, 46, 54, 0.8)
    line-height 25px
    margin-bottom 24px
  .stem
    font-size 16px
    font-family MicrosoftYaHeiUI
    color rgba(42, 46, 54, 0.75)
    line-height 28px
.start
  width:112px!important;
  height:40px!important;
  background:rgba(68,133,240,1);
  box-shadow:0px 0px 4px 2px rgba(255,255,255,0.8);
  border-radius:4px;
  border none
  width:28px;
  height:18px;
  font-size:14px;
  font-family:MicrosoftYaHeiUI;
  color:rgba(255,255,255,1);
  line-height:18px;
  position absolute
  bottom 0
  right 0
  outline none
@keyframes myfirst
  from
    left 60px
    top 0
  to
    left 80px
    top 20px
.finger
  z-index 99999
  position relative
  left 60px
  top 0
  // transition 1s
  animation myfirst .5s infinite
  animation-direction:alternate;
.text-Explain
  font-size:20px;
  font-family:STYuanti-SC-Bold,STYuanti-SC;
  font-weight:bold;
  color:rgba(255,255,255,1);
  white-space: nowrap;
  position: absolute;
</style>
